module.exports = __webpack_public_path__ + "img/timeline.f0da7483.svg";